export const name = 'rnDcs';
export default function rnDcs($q, $log, $filter, rnHttp) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const DCS_SERVICE_NAME = 'dcs_service';
  const DEVICES_PATH = 'devices/';
  const DELIVERY_CAPABILITIES_PATH = 'deliverycapabilities/';

  var service = {
    getAll: getAll,
    getById: getById,
    createDevice: createDevice,
    updateDevice: updateDevice,
    deleteDevice: deleteDevice,
    getDeliveryCapabilities: getDeliveryCapabilities
  };

  return service;

  //////////////

  function getAll(offset, limit) {
    let params = { offset: offset, limit: limit };
    let config = { params: params, version: 2};

    return rnHttp.get(DCS_SERVICE_NAME, DEVICES_PATH, config)
      .then(rnHttp.resolveWithData)
      .catch(rnHttp.rejectWithSmsError);
  }

  function getById(id) {
    return rnHttp.get(DCS_SERVICE_NAME, DEVICES_PATH + id, {version: 2})
      .then(rnHttp.resolveWithData)
      .catch(rnHttp.rejectWithSmsError);
  }

  function createDevice(device) {
    return rnHttp.post(DCS_SERVICE_NAME, DEVICES_PATH, device, {version: 2})
      .then(rnHttp.resolveWithData)
      .catch(rnHttp.rejectWithSmsError);
  }

  function updateDevice(deviceObject) {
    let link = _.get(deviceObject, 'device._links.update', null);

    if (!link) {
      return $q.reject('No update link included');
    }

    return rnHttp.halRequest(link, deviceObject)
      .then(rnHttp.resolveWithData)
      .catch(rnHttp.rejectWithSmsError);
  }

  function deleteDevice(id, password) {
    return rnHttp.deleteWithBody(DCS_SERVICE_NAME, DEVICES_PATH + id, password, {version: 2})
      .catch(rnHttp.rejectWithSmsError);
  }

  function getDeliveryCapabilities() {
    return rnHttp.get(DCS_SERVICE_NAME, DELIVERY_CAPABILITIES_PATH, {version: 2})
      .then(rnHttp.resolveWithData)
      .catch(rnHttp.rejectWithSmsError);
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/device/dcs.service.js